export enum HEAP_EVENT_NAMES {
  REP_MEDIA_UPLOAD = 'Rep Media Upload',
  DISPLAY_UPGRADE_MODAL = 'Display Upgrade Modal',
  SUCCESSFUL_TALENT_SIGN_UP = 'Successful Talent Sign Up',
  HOVER_IN_MR_ICON_SCHEDULER = 'Hover In MR Icon-Scheduler',
  TALENT_LOGIN_NAV_SUCCESSFUL_LOGIN = 'Talent - Login - Nav - Successful Login',
  TALENT_LOGIN_NAV_FAILED_LOGIN = 'Talent - Login - Nav - Failed Login',
  TALENT_LOGIN_NAV_RESET_PASSWORD = 'Talent - Login - Nav - Reset Password',
  TALENT_LOGIN_NAV_LEGACY_RESET_PASSWORD = 'Talent - Login - Nav - Legacy Reset Password',
  TALENT_SOCIAL_ADD_LINK = 'Talent - Social - Add Link',
  TALENT_SOCIAL_CLICK_CONNECT_INSTAGRAM = 'Talent - Click - Connect - Instagram',
  TALENT_SOCIAL_CLICK_CONNECT_YOUTUBE = 'Talent - Click - Connect - Youtube',
  TALENT_SOCIAL_CLICK_CONNECT_TIKTOK = 'Talent - Click - Connect - TikTok',
  TALENT_SOCIAL_FOLLOWER_COUNT_VIEW = 'Talent - Social - Follower Count View',
  TALENT_SOCIAL_LINK_ADD_SUCCESS = 'Talent - Social - Link Add Success',
  TALENT_SOCIAL_LINK_ADD_ERROR = 'Talent - Social - Link Add Error',
  TALENT_SOCIAL_CLICK_UPGRADE_TO_PREMIUM = 'Talent - Social - Click Upgrade to Premium',
  TALENT_CLICK_HEADSHOTS_TRIAL_UPGRADE_MODULE_UPGRADE_NOW = 'Talent - Click - Headshots Trial Upgrade Module - Upgrade Now',
  CD_INSTAGRAM_CLICK_BASEBALL_CARD = 'CD - Instagram - Click Baseball Card',
  CD_YOUTUBE_CLICK_BASEBALL_CARD = 'CD - YouTube - Click Baseball Card',
  CD_TIKTOK_CLICK_BASEBALL_CARD = 'CD - TikTok - Click Baseball Card',
  CD_INSTAGRAM_CLICK_TALENT_PROFILE = 'CD - Instagram - Click Talent Profile',
  CD_YOUTUBE_CLICK_TALENT_PROFILE = 'CD - Youtube - Click Talent Profile',
  CD_TIKTOK_CLICK_TALENT_PROFILE = 'CD - TikTok - Click Talent Profile',
  CD_BASEBALL_CARD_ACTION = 'CD - Baseball - Card Action',
  CD_CLICK_TALENT_PROFILE = 'CD - Click Talent Profile',
  OPEN_CALLS_TOGGLE_CLICKED = 'Open Calls Toggle Clicked',
  REP_UPLOAD_PRIMARY_PHOTO_ON_SUBMISSION = 'Upload Primary Photo on Submission',
  REP_SAVE_SUBMISSION_CUSTOMIZATION = 'Reps Save Submission Customization',
  CD_SELECT_NUMBER_SELECTION_TAGS = 'Select-Number-Selection-Tags',
  CD_SELECT_LETTER_SELECTION_TAGS = 'Select-Letter-Selection-Tags',
  COPY_TO_CAST_IT_SUCCESS = 'Copy to Cast It Success',
  COPY_TO_CAST_IT_FAILED_TO_COPY = 'Copy to Cast It Failed to Copy',
  COPY_TO_CAST_IT_STUDIO_SUCCESS = 'Copy to Cast It Studio Success',
  COPY_TO_CAST_IT_STUDIO_FAILED_TO_COPY = 'Copy to Cast It Studio Failed to Copy',
  COPY_TO_CAST_IT_STUDIO_NO_MEDIA_TO_COPY = 'Copy to Cast It Studio No Media To Copy',
  RETRY_COPY_TO_CAST_IT = 'Retry Copy to Cast It',
  REACTIVATION_MODAL_VIEW = 'reactivation_modal_view',
  REACTIVATION_MODAL_CTA_CLICK = 'reactivation_modal_cta_click',
  REACTIVATION_MODAL_PURCHASE_SUCCESS = 'reactivation_modal_purchase_success',
  REACTIVATION_MODAL_DISMISS = 'reactivation_modal_dismiss',
  ADD_TALENT_TO_EXISTING_MEDIA_REQUEST = 'Add to Existing Media Request',
  ADD_TALENT_WITH_CREATE_NEW_MEDIA_REQUEST = 'Create New Media Request',
  REP_SUBMIT_ALL_SELECTIONS = 'Submit All Selections',
  GLOBAL_PROFILE_BANNER_CTA_CLICKED = 'global_profile_banner_cta_clicked',
  BILLING_INFO_CANCEL_CTA_CLICKED = 'billing_info_cancel_cta_clicked',
  CREATE_LIVE_SHARE_TALENT_LINK = 'Create Live Share Talent Link',
  CREATE_SNAPSHOT_SHARE_TALENT_LINK = 'Create Snapshot Share Talent Link',
  SIGNUP_CHECKOUT_STARTED = 'Talent - Sign up - checkout_started',
  SIGNUP_BILLING_ADDRESS_FIELD_STARTED = 'Talent - Sign up - billing_address_field_started',
  SIGNUP_BILLING_ADDRESS_AUTOFILL_USED = 'Talent - Sign up - billing_address_autofill_used',
  SIGNUP_BILLING_ADDRESS_COMPLETED = 'Talent - Sign up - billing_address_completed',
  SIGNUP_BILLING_ADDRESS_EDIT_CLICKED = 'Talent - Sign up - billing_address_edit_clicked',
  SIGNUP_CHECKOUT_SUBMITTED = 'Talent - Sign up - checkout_submitted',
  SIGNUP_CHECKOUT_COMPLETED = 'Talent - Sign up - checkout_completed',
  SIGNUP_CHECKOUT_ABANDONED = 'Talent - Sign up - checkout_abandoned',
  SIGNUP_ADDRESS_VALIDATION_RESPONSE = 'Talent - Sign up - address_validation_response',
  SIGNUP_ADDRESS_VALIDATION_MODAL_SHOWN = 'Talent - Sign up - address_validation_modal_shown',
  SIGNUP_ADDRESS_VALIDATION_SUGGESTION_CLICKED = 'Talent - Sign up - address_validation_suggestion_clicked',
  SIGNUP_ADDRESS_VALIDATION_NEXT_CLICKED = 'Talent - Sign up - address_validation_next_clicked',
  SIGNUP_ADDRESS_VALIDATION_EXIT_CLICKED = 'Talent - Sign up - address_validation_exit_clicked',
  SIGNUP_ADDRESS_VALIDATION_CHECKOUT_COMPLETED = 'Talent - Sign up - address_validation_checkout_completed',
  UPGRADE_CHECKOUT_STARTED = 'Talent - Upgrade modal - checkout_started',
  UPGRADE_BILLING_ADDRESS_FIELD_STARTED = 'Talent - Upgrade modal - billing_address_field_started',
  UPGRADE_BILLING_ADDRESS_AUTOFILL_USED = 'Talent - Upgrade modal - billing_address_autofill_used',
  UPGRADE_BILLING_ADDRESS_COMPLETED = 'Talent - Upgrade modal - billing_address_completed',
  UPGRADE_BILLING_ADDRESS_EDIT_CLICKED = 'Talent - Upgrade modal - billing_address_edit_clicked',
  UPGRADE_CHECKOUT_SUBMITTED = 'Talent - Upgrade modal - checkout_submitted',
  UPGRADE_CHECKOUT_COMPLETED = 'Talent - Upgrade modal - checkout_completed',
  UPGRADE_CHECKOUT_ABANDONED = 'Talent - Upgrade modal - checkout_abandoned',
}
